export const FRONTEND =
  process.env.NODE_ENV === 'production'
    ? 'https://app.prodigiesacademy.com'
    : 'https://qa-app.prodigiesacademy.com'
